/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JobId
 */
export interface JobId {
    /**
     * 
     * @type {number}
     * @memberof JobId
     */
    id?: number;
}

/**
 * Check if a given object implements the JobId interface.
 */
export function instanceOfJobId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JobIdFromJSON(json: any): JobId {
    return JobIdFromJSONTyped(json, false);
}

export function JobIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function JobIdToJSON(value?: JobId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

